/**
 * Client-side score history row normalization with user isolation guards.
 */

const BUREAU_KEYS = ['transunion', 'experian', 'equifax'];

export const normalizeScoreHistoryRows = (rows, effectiveUserId) => {
  if (!Array.isArray(rows)) return [];

  const seenReportIds = new Set();
  const normalized = [];

  rows.forEach((row) => {
    if (!row) return;

    const reportId = row.report_id || row.id || null;
    if (!reportId) return;

    if (effectiveUserId && row.user_id && row.user_id !== effectiveUserId) return;

    if (seenReportIds.has(reportId)) return;
    seenReportIds.add(reportId);

    const hasScore = BUREAU_KEYS.some(
      (bureau) => row[bureau] != null && row[bureau] !== '' && row[bureau] !== '—',
    );
    if (!hasScore) return;

    normalized.push({
      report_id: reportId,
      user_id: row.user_id || effectiveUserId || null,
      imported_at: row.imported_at || null,
      date: row.display_import_date || row.display_date || row.date || null,
      display_import_date: row.display_import_date || row.display_date || row.date || null,
      display_report_date: row.display_report_date || null,
      transunion: row.transunion ?? null,
      experian: row.experian ?? null,
      equifax: row.equifax ?? null,
      is_latest: Boolean(row.is_latest),
    });
  });

  return normalized.sort((a, b) => {
    const aTime = Date.parse(a.imported_at || '') || Date.parse(a.date || '') || 0;
    const bTime = Date.parse(b.imported_at || '') || Date.parse(b.date || '') || 0;
    return bTime - aTime;
  });
};
